
import { defineComponent } from "vue";
import QrcodeVue from "qrcode.vue";

export default defineComponent({
  components: { QrcodeVue },
  name: "QR",
  props: {
    value: { type: String, required: true },
    size: { type: Number, required: true },
    foreground: String,
  },
});
